import axios from "axios";
import { Loading, Message } from "element-ui";
import * as _storage from '@/utils/storage.js';
let needLoadingRequestCount = 0;

function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
}

function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) {
    return false;
  }
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
}

let loading;

function startLoading() {
  loading = Loading.service({
    lock: true,
    text: "加载中……",
    background: "rgba(0, 0, 0, 0.2)"
  });
}

function endLoading() {
  loading.close();
}

// 请求超时 请求头
axios.defaults.timeout = 20000;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

const setToken = () => {
  const userInfo = _storage.getStorageSync("userInfo") || "";
  return userInfo ? { token: `${userInfo.token}` } : {};
};
const setCollegeId = () => {
  const collegeId = _storage.getStorageSync("collegeId") || "";
  return collegeId ? { collegeId: `${collegeId}` } : {};
};
const setMonitorCode = () => {
  const monitorData = _storage.getStorageSync("monitorData") || "";
  return monitorData ? { monitorCode: `${monitorData.monitorCode}` } : {};
};
const setSessionId = () => {
  const sessionId = _storage.getStorageSync("sessionId") || "";
  return sessionId ? { sessionId: sessionId } : {};
};
// 请求拦截器
axios.interceptors.request.use(
  config => {
    if (config.showLoading) {
      showFullScreenLoading();
    }
    const token = setToken();
    const monitorCode = setMonitorCode();
    const sessionId = setSessionId();
    const collegeId = setCollegeId();
    let { headers } = config;
    headers = {
      ...headers,
      ...token,
      ...collegeId,
      ...sessionId,
      ...monitorCode
    };
    return { ...config, headers: headers };
  },
  err => {
    throw err;
  }
);

// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.config.showLoading) {
      tryHideFullScreenLoading();
    }
    if (
      response.data &&
      response.data.code < 400 &&
      response.data.code >= 200
    ) {
      return response.data.data;
    } else {
      window.core.showTopTip(1, response.data.msg || response.data.message)
      console.log(Message)
      // Message.error(response.data.msg || response.data.message);
      if (response.data && response.data.code == "000") {
        const { monitorId } = this.roomData
        window.core.logoutRoom(monitorId)
        _storage.removeStorageSync("userInfo");
        window.location.href = window.location.origin + window.location.pathname + "#/login";
      }
      if (response.data && response.data.code == "501") {
        const { monitorId } = this.roomData
        window.core.logoutRoom(monitorId)
        _storage.removeStorageSync("userInfo");
        window.location.href = window.location.origin + window.location.pathname + "#/login";
      }
      if (response.data && response.data.code == "504") {
        const { monitorId } = this.roomData
        window.core.logoutRoom(monitorId)
        _storage.removeStorageSync("userInfo");
        window.location.href = window.location.origin + window.location.pathname + "#/login";
      }
      throw new Error(response.data.msg || response.data.message);
    }
  },
  err => {
    tryHideFullScreenLoading();
    throw err;
  }
);

const ajax = {
  /**
   * get方法，对应get请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  get: (url, params, showLoadingOptions = { showLoading: true }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          params: params,
          ...showLoadingOptions
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /**
   * delete，对应delete请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  del: (url, params, showLoadingOptions = { showLoading: true }) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(url, {
          params: params,
          showLoading: true,
          ...showLoadingOptions
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  /**
   * post方法，对应post请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  post: (
    url,
    data,
    params = {},
    showLoadingOptions = { showLoading: true }
  ) => {
    return new Promise((resolve, reject) => {
      // axios.post(url, params, showLoadingOptions)
      //   .then(res => {
      //     resolve(res)
      //   })
      //   .catch(err => {
      //     reject(err)
      //   })
      axios({
        url: url,
        method: "post",
        data: data,
        params: params,
        ...showLoadingOptions
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  /**
   * 封装patch请求
   * @param url
   * @param params
   * @returns {Promise}
   */
  patch: (url, params, showLoadingOptions = { showLoading: true }) => {
    return new Promise((resolve, reject) => {
      axios.patch(url, params, showLoadingOptions).then(
        response => {
          resolve(response);
        },
        err => {
          reject(err);
        }
      );
    });
  },

  /**
   * put 请求
   * @param  url
   * @param  params
   */
  put: (url, params, showLoadingOptions = { showLoading: true }) => {
    return new Promise((resolve, reject) => {
      axios.put(url, params, showLoadingOptions).then(
        response => {
          resolve(response);
        },
        err => {
          reject(err);
        }
      );
    });
  }
};

export default ajax;
